import { render, staticRenderFns } from "./Cate.vue?vue&type=template&id=03f1444a&scoped=true&"
import script from "./Cate.vue?vue&type=script&lang=js&"
export * from "./Cate.vue?vue&type=script&lang=js&"
import style0 from "./Cate.vue?vue&type=style&index=0&id=03f1444a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f1444a",
  null
  
)

export default component.exports